export default __webpack_public_path__ + "files/ncsa logo-8262f1c21801db5a825739eb0f005c32.png";